import QRCode from 'qrcode';
import { InventoryQRData } from '../components/InventoryQRScannerDialog';

export interface InventoryQRService {
  generateQRCode(
    inventoryId: string,
    inventoryCode: string,
    inventoryName: string
  ): Promise<string>;
  generateQRCodeSVG(
    inventoryId: string,
    inventoryCode: string,
    inventoryName: string
  ): Promise<string>;
}

export class InventoryQRServiceImpl implements InventoryQRService {
  async generateQRCode(
    inventoryId: string,
    inventoryCode: string,
    inventoryName: string
  ): Promise<string> {
    const qrData: InventoryQRData = {
      type: 'INVENTORY',
      inventoryId,
      inventoryCode,
      inventoryName,
      timestamp: Date.now(),
    };

    try {
      const qrCodeString = await QRCode.toString(JSON.stringify(qrData), {
        type: 'utf8',
        width: 200,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      });

      return qrCodeString;
    } catch (error) {
      console.error('Failed to generate QR code:', error);
      throw new Error('QR code generation failed');
    }
  }

  async generateQRCodeSVG(
    inventoryId: string,
    inventoryCode: string,
    inventoryName: string
  ): Promise<string> {
    const qrData: InventoryQRData = {
      type: 'INVENTORY',
      inventoryId,
      inventoryCode,
      inventoryName,
      timestamp: Date.now(),
    };

    try {
      const qrCodeSVG = await QRCode.toString(JSON.stringify(qrData), {
        type: 'svg',
        width: 200,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      });

      return qrCodeSVG;
    } catch (error) {
      console.error('Failed to generate QR code SVG:', error);
      throw new Error('QR code SVG generation failed');
    }
  }
}

// Export singleton instance
export const inventoryQRService = new InventoryQRServiceImpl();
